const initialState = [];

function userOrganisationRolesReducer(state = initialState, action) {
  switch (action.type) {
    case "userOrganisationRoles/add":
      return [...state, action.payload];
    case "userOrganisationRoles/remove":
      return state.filter((role) => role.id !== action.payload);
    case "userOrganisationRoles/update":
      return Array.isArray(action.payload) ? action.payload : [];
    default:
      return state;
  }
}

export default userOrganisationRolesReducer;
